/**
 * 销售订单
 */
 import React from 'react';
 import { Modal, Input, Button, Row, Col, Icon, Tooltip, Select, DatePicker } from 'antd';
 import PageLayout from '../../ui/PageLayout';
 import http from '../../../axios/http';
 import Loading from '../../ui/Loading';
 import messager from '../../ui/messager';
 //编辑
 import VehicleSellEdit from './VehicleSellEdit';
 //详情
 import VehicleSellDetail from './VehicleSellDetail';
 import { global_data } from '../../ui/auth';
 import OrgSelect from '../../ui/OrgSelect';
 
 class VehiclePurchaseIndex extends React.Component {
   columns = [{
     title: '订单编号',
     dataIndex: 'orderNo',
     width: '12%',
   }, {
     title: '车架号',
     dataIndex: 'vehicleOrderItemList[0].vin',
     width: '10%',
   }, {
     title: '车牌号',
     dataIndex: 'vehicleOrderItemList[0].plateNo',
     width: '6%',
   }, {
     title: '厂牌型号',
     dataIndex: 'vehicleOrderItemList[0].vehicleName',
     width: '10%',
   }, {
     title: '买家名称',
     dataIndex: 'buyerName',
     width: '8%',
   }, {
     title: '卖家名称',
     dataIndex: 'sellerName',
     width: '8%',
   }, {
     title: '订单状态',
     dataIndex: 'orderStatus',
     width: '6%',
     format: { "0":"创建","1":"申请","2":"已通过","3":"已拒绝","21":"待签约","31":"合同已拒绝","4":"已取消","5":"已签约","6":"待付款","7":"已付款","8":"已移交","9":"已入库","10":"已出库"},
    // format: { "":"全部","2":"已通过","4":"已取消","21":"待签约","5":"已签约"},
   }, {
     title: '车辆金额',
     dataIndex: 'vehicleOrderItemList[0].price',
     width: '8%',
   }
   , {
    title: '创建人',
    dataIndex: 'name',
    width: '6%',
    }
    ,{
     title: '订单日期',
     dataIndex: 'createTime',
     width: '10%',
   }, {
     title: '操作',
     dataIndex: 'id',
     width: '6%',
     render: (text, record, index) => (
       <div>
        {global_data.authCode.includes("VEHICLE_SELL_INDEX_UPDATE")&&(Number(record.orderStatus)===2||Number(record.orderStatus)===4)?
         <Tooltip title="编辑">
           <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
         </Tooltip>:''}
         {global_data.authCode.includes("VEHICLE_SELL_INDEX_PASS")&&(Number(record.orderStatus)===1)?
        <Tooltip title="标记为已通过">
            <Icon type="highlight" theme="filled" className="table-operate-icon" onClick={this.changeStatusTo.bind(this, record)} />
        </Tooltip>:''}
        {
           global_data.authCode.includes("VEHICLE_SELL_INDEX_RETURN")&&(Number(record.orderStatus)===5)?
                <Tooltip title="退回重签">
                    <Icon type="undo" className="table-operate-icon" onClick={this.undoStatus.bind(this, record)} />
                </Tooltip>
                : ""
        }
         <Tooltip title="查看">
           <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
         </Tooltip>
       </div>
     )
   }];
 
   state = {
     // loadData: '',
     queryData: {
        orderType: 1,
        pageNumber: 1,
       // pageSize: 10
     }, //查询数据
     loadingVisible: false,
 
     //编辑页面使用的数据信息
     editVisible: false,
     editData: {},
 
     detailVisible: false,
     detailData: {},
     amount:"0"
   };
 
   componentDidMount() {
      this.loadOrderSum(this.state.queryData);
   }

   loadOrderSum = (queryData) => {
    http.post({
        url: '/vehicleOrder/sum',
        data: queryData,
        success: (res) => {
            this.setState({
                amount: res.totalAmount 
            });
        }
    });
  }

  loadPageData = (queryData) => {
    this.state.loadData(queryData);
    this.loadOrderSum(queryData);
  }
 
   //新增
  add = (info, e) => {
    let editData = {
    };
    this.setState({
        editData: editData,
        editVisible: true
    });
    this.initEdit(editData);
  }
 
   // 导出
   download = () => {
     let queryData = this.state.queryData;
     if (queryData.startTime == null || queryData.endTime === "") {
         messager.notify("导出时需选择时间段！", null, "warning");
         return;
     }
     this.setState({ loadingVisible: true });
     let fileName = queryData.startTime + "~" + queryData.endTime + "-vehicle-purchase-detail.xlsx";
     http.download({
       url: '/vehicleOrder/excel',
       data: queryData,
       fileName: fileName,
       success: (res) => {
         this.setState({ loadingVisible: false });
       }
   });
   messager.notify("只会根据查询的时间段导出已经打印的数据！");
   }
 
   //编辑
   update = (info, e) => {
     // this.setState({ loadingVisible: true });
     http.get({
       url: '/vehicleOrder/get',
       data: {id:info.id},
       success:(res)=>{
        if(res.success){
         let editData = res.data
         http.get({
           url: '/vehicleBase/getVehicleBase',
           data: {vin:res.data.vehicleOrderItemList[0].vin},
           success: (r1) => {
             let vehicleBaseObj = {}
             if(r1.success){
              if(r1.data){
                for(let i in r1.data){
                  vehicleBaseObj['vehicleBaseObj_'+i] = r1.data[i]
                }
              }
              for(let i in editData.vehicleOrderItemList[0]){
                vehicleBaseObj['vehicleBaseObj_'+i] = editData.vehicleOrderItemList[0][i]
              }
              this.setState({ editData:{...editData,...vehicleBaseObj,pickDateStr:editData.pickDate},vehicleBaseObj, editVisible: true, loadingVisible: false});
              this.initEdit({...editData,...vehicleBaseObj,pickDateStr:editData.pickDate});
             }else{
              messager.alert(r1.errorMessage, "异常", "error");
             }
           }
         })
        }else{
          messager.alert(res.errorMessage, "异常", "error");
        }
       }
     })
   }
 
   //标记为已通过
  changeStatusTo = (info, e) => {
    Modal.confirm({
      title: '提示',
      content: '是否标记为已通过？',
      okText: '确认',
      cancelText: '再想想',
      onOk: () => {
        http.post({
          url: '/vehicleOrder/changeStatus',
          data: { orderNo: info.orderNo, orderStatus: 2 },
          success: (res) => {
            if(res.success){
              this.loadPageData();
              messager.notify('标记成功');
              this.setState({ visible: false, loading: false });
            }else{
              messager.notify(res.errorMessage);
            }
          }
        })
      }
    });
  }

  // 退回重签
  undoStatus = (info, e) => {
    Modal.confirm({
      title: '提示',
      content: '是否退回重签？',
      okText: '确认',
      cancelText: '再想想',
      onOk: () => {
        http.post({
          url: '/vehicleOrder/undoStatus',
          data: { id: info.id, status: 2 },
          success: (res) => {
            if(res.success){
              this.loadPageData()
              messager.notify('退回成功');
              this.setState({ visible: false, loading: false });
            }else{
              messager.notify(res.errorMessage);
            }
          }
        })
      }
    });
  }
 
 
   detail = (info, e) => {
     http.get({
       url: '/vehicleOrder/get',
       data: {id:info.id},
       success:(res)=>{
        if(res.success){
          let detailData = res
          this.setState({ detailData: detailData, detailVisible: true, loadingVisible: false});
          this.initDetail(detailData);
        }else{
          messager.alert(res.errorMessage, "异常", "error");
        }
       }
     })
   }
 
 
   inputSearch = (field, value) => {
     let queryData = this.state.queryData;
     queryData[field] = value;
     this.setState({ queryData: queryData });
     this.loadPageData(queryData)
   }
 
   inputChange = (field, value) =>{
     let queryData = this.state.queryData
     queryData[field] = value;
     this.setState({ queryData: queryData });
   }
 
   rangePickerChange = (dates, dateStrings) => {
     let queryData = this.state.queryData;
     queryData.startTime = dateStrings[0];
     queryData.endTime = dateStrings[1];
     this.setState({ queryData: queryData });
     this.loadPageData(queryData);
   }
 
   selectChange = (value) => {
     let queryData = this.state.queryData;
     queryData.orderStatus = value;
     this.setState({ queryData: queryData });
     this.loadPageData(queryData)
   }

   //所属市场查询
  orgSelect = (value) => {
    let queryData = this.state.queryData;
    queryData["orgCode"] = value;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData)
  }
 
   showModalEdit = () => {
     this.setState({ editVisible: true });
   }
   hiddenModalEdit = () => {
     this.setState({ editVisible: false });
   }
 
   render() {
     return (
       <div style={{ width: '100%', height: '100%' }}>
         <PageLayout
           condition={(
             <Row>
               <Col span={20}>
                 <Input.Search
                   placeholder="车牌号/车架号"
                   onSearch={this.inputSearch.bind(this, "keywords")}
                   onChange={this.inputChange.bind(this, "keywords")}
                   enterButton
                   allowClear
                   style={{ width: '150px', marginRight: '10px' }}
                 />
                 <Input.Search
                   placeholder="买家名称"
                   onSearch={this.inputSearch.bind(this, "buyerName")}
                   onChange={this.inputChange.bind(this, "buyerName")}
                   enterButton
                   allowClear
                   style={{ width: '150px', marginRight: '10px' }}
                 />
                 <Input.Search
                   placeholder="卖家名称"
                   onSearch={this.inputSearch.bind(this, "sellerName")}
                   onChange={this.inputChange.bind(this, "sellerName")}
                   enterButton
                   allowClear
                   style={{ width: '150px' }}
                 />
                 <Select placeholder="订单状态" style={{ width: 100, marginLeft: '10px', marginRight: '10px' }} onChange={this.selectChange}>
                 <Select.Option value="">全部</Select.Option>
                  {/* <Select.Option value="0">创建</Select.Option> */}
                  {/* <Select.Option value="1">申请</Select.Option> */}
                  <Select.Option value="2">已通过</Select.Option>
                  {/* <Select.Option value="3">已拒绝</Select.Option> */}
                  <Select.Option value="21">待签约</Select.Option>
                  {/* <Select.Option value="31">合同已拒绝</Select.Option> */}
                  <Select.Option value="4">已取消</Select.Option>
                  <Select.Option value="5">已签约</Select.Option>
                  {/* <Select.Option value="6">待付款</Select.Option>
                  <Select.Option value="7">已付款</Select.Option>
                  <Select.Option value="8">已移交</Select.Option>
                  <Select.Option value="9">已入库</Select.Option>
                  <Select.Option value="10">已出库</Select.Option> */}
                 </Select>
                 <DatePicker.RangePicker onChange={this.rangePickerChange} />
                 <OrgSelect style={{ width: '150px',marginLeft: '10px' }}
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                 <Button type='text' style={{marginLeft: '10px',paddingTop:'0px'}}>总合同金额：{this.state.amount}</Button>
               </Col>
               <Col span={4} style={{ textAlign: "right" }}>
                  {global_data.authCode.includes("VEHICLE_SELL_INDEX_ADD")?
                  <Button type="primary" onClick={this.add.bind(this)} style={{ marginRight: '10px' }}>新增</Button>
                  :""}
                 <Button type="primary" onClick={this.download.bind(this)}>导出</Button>
               </Col>
             </Row>
           )}
           rowKey="id"
           url="/vehicleOrder/page"
           columns={this.columns}
           initParams={this.state.queryData}
           totalElements={100}
           loadData={(func) => { this.setState({ loadData: func }); }} />
 
         <VehicleSellEdit
           visible={this.state.editVisible}
           onCancel={() => {this.setState({ editVisible: false }) }}
           editData={this.state.editData}
           initParams={this.state.queryData}
           successCallback={this.loadPageData}
           queryData={this.state.queryData}
           initFunc={(func) => { this.initEdit = func }}
         />
 
         <VehicleSellDetail 
         visible={this.state.detailVisible}
         initParams={this.state.queryData}
         successCallback={this.loadPageData}
         detailData={this.state.detailData}
         onCancel={() => { this.setState({ detailVisible: false }); }}
         initDetail={(func) => { this.initDetail = func }}
         />
         <Loading
           visible={this.state.loadingVisible}
           message="数据加载中"
         />
       </div>
     )
   }
 }
 
 export default VehiclePurchaseIndex;